import { createActionGroup, props } from '@ngrx/store';
import * as fromGenerated from '../../_generated';
import { FeatureFlagView } from './feature-flags.reducer';

export const FeatureFlagsActions = createActionGroup({
  source: 'Feature Flags Actions',
  events: {
    /**
     * Load Feature Flags
     */
    'Load Feature Flags': props<{ featureFlags: FeatureFlagView[] }>(),
    /**
     * Identify User
     */
    'Identify User': props<{
      user: fromGenerated.UserView;
    }>(),
    /**
     * On Change Sync
     */
    'On Change Sync Success': props<{ featureFlags: FeatureFlagView[] }>(),
    /**
     * On Error
     */
    'On Error': props<{ error: Error }>(),
  },
});
